import React from "react";
import { useState, useEffect, useContext } from "react";
import Details from "./Details";
import Edit from "./Edit";
import Pirsomeem from "./pirsom/Pirsomeem";
import Exts from "./extentions/Exts";
import AmotMeda from "./amotmeda/AmotMeda";
import MyonMakdeem from "./myonmakdeem/MyonMakdeem";
import Assessments from "./assessments/Assessments";
import Documents from "./documents/Documents";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { ImForward } from "react-icons/im";
import Moamadeem from "./moamadeem/Moamadeem";
import GetDepartment from "../shared/GetDepartment";
import MekhrazContext from "./MekhrazContaxt";
import HandleHttpErrors from "../HandleHttpErrors";
import AuditModal from "../shared/AuditModal";
import AuditContext from "../shared/context/AuditProvider";
const baseURL = process.env.REACT_APP_API_JOBS;

const MekhrazAdmin = (props) => {
  const { id } = useParams();
  const { showAudit, setShowAudit, model, setModel, srcId, setSrcId } =
    useContext(AuditContext);
  const [page, setPage] = useState(1);
  const [mekhraz, setMekhraz] = useState({});
  const [departmentsList, setDepartmentsList] = useState([]);
  const [jobsList, setJobsList] = useState([]);
  const [ptorReasonsList, setPtorReasonsList] = useState([]);
  const [mekhrazUpdated, setMekhrazUpdated] = useState(false);
  const [loading, setLoading] = useState(true);
  let axiosPrivate = useAxiosPrivate();
  let navigate = useNavigate();
  let location = useLocation();
  useEffect(() => {
    // When component mounts, check if 'savedPage' exists in localStorage
    const savedPage = localStorage.getItem("savedPage");
    // If savedPage exists and you want to default to Moamadeem (page 9)
    if (savedPage) {
      setPage(parseInt(savedPage)); // Assuming setPage is the function to update the page state
    }
  }, []);

  useEffect(() => {
    // Save the page state to localStorage whenever it changes
    if (page != 6) {
      localStorage.setItem("savedPage", page);
    } else {
      localStorage.setItem("savedPage", 1);
    }
  }, [page]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "mekhraz/" + id, {
          signal: controller.signal,
        });
        if (isMounted) {
          setMekhraz(response.data);
          setSrcId(response.data.id);
          setModel("Mekhraz");
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
    setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [mekhrazUpdated]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "department/", {
          signal: controller.signal,
        });
        setDepartmentsList(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
      try {
        const response = await axiosPrivate.get(baseURL + "jobslist/", {
          signal: controller.signal,
        });
        setJobsList(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
      try {
        const response = await axiosPrivate.get(baseURL + "ptorreason/", {
          signal: controller.signal,
        });
        setPtorReasonsList(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
  }, []);

  const gotoBhina = async (e) => {
    const department = await GetDepartment({
      departmentsList,
      depIndex: mekhraz.department,
    });
    // navigate("/bhinameetingadmin/" + id + "/" + department);
    navigate("/bhinameetingadmin/" + id + "/" + encodeURIComponent(department));
  };

  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        {showAudit && <AuditModal />}
        <nav className="navbar navbar-expand-md bg-dark navbar-dark fixed-right ">
          <h6
            onClick={() => {
              setShowAudit(true);
            }}
            className="navbar-brand mb-0 h6 text-center"
            style={{ whiteSpace: "pre-line" }}
          >
            <br />
            {mekhraz.title}
          </h6>
          <ul className="navbar-nav flex-column ml-auto">
            <li className="nav-item ">
              <button
                className="btn btn-primary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => navigate(-1)}
              >
                <ImForward />
                חזרה
              </button>
            </li>
            <li className="nav-item active">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(1)}
              >
                פרטי המכרז
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(2)}
              >
                עריכה
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(3)}
              >
                הארכות
              </button>
            </li>
            <li>
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(4)}
              >
                פרסום
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => {
                  setPage(7);
                }}
              >
                מיון מקדים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(5)}
              >
                אמות מידה
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => {
                  setPage(8);
                }}
              >
                מסמכים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => {
                  setPage(10);
                }}
              >
                מבחנים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  setPage(6);
                  gotoBhina();
                }}
              >
                וועדת בחינה
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-secondary navbar-btn md-button"
                onClick={() => {
                  setPage(9);
                }}
              >
                מועמדים
              </button>
            </li>
          </ul>
        </nav>
        <div style={{ paddingRight: "100px" }}>
          <MekhrazContext.Provider
            value={{ mekhrazUpdated, setMekhrazUpdated }}
          >
            {page === 1 && (
              <Details
                visible={page == 1}
                mekhraz={mekhraz}
                id={id}
                departmentsList={departmentsList}
                jobsList={jobsList}
                ptorReasonsList={ptorReasonsList}
              />
            )}

            {page === 2 && (
              <Edit
                visible={page == 2}
                id={id}
                mekhraz={mekhraz}
                jobsList={jobsList}
              />
            )}
            {page === 3 && (
              <Exts
                visible={page == 3}
                mekhraz={mekhraz}
                setMekhrazUpdated={setMekhrazUpdated}
              />
            )}
            {page === 4 && <Pirsomeem visible={page == 4} mekhraz={mekhraz} />}
            {page === 5 && (
              <AmotMeda visible={page == 5} mekhraz={mekhraz} mekhraz_id={id} />
            )}
            {page === 7 && <MyonMakdeem visible={page == 7} mekhraz_id={id} />}
            {page === 8 && <Documents visible={page == 8} mekhraz={mekhraz} />}
            {page === 9 && (
              <Moamadeem
                visible={page == 9}
                mekhraz_id={id}
                mekhraz_title={mekhraz?.title}
                mkh_num={mekhraz?.mkh_num}
                mkh_hagasha_date={mekhraz?.hagsha_date}
              />
            )}
            {page === 10 && (
              <Assessments visible={page == 10} mekhraz_id={id} />
            )}
          </MekhrazContext.Provider>
        </div>
      </>
    );
  }
};

export default MekhrazAdmin;
